// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_page_container {
  flex-direction: column;
  row-gap: 10px;
  column-gap: 0px;
  display: flex;
  height: 100%;
  color: white;
  z-index: 1;
  padding: 180px 70px 70px;
}

.completed_cars_container {
  z-index: 1;
  flex-direction: column;
  row-gap: 10px;
  column-gap: 10px;
  display: flex;
  justify-content: space-between;
  padding: 130px 50px 10px;
}

.car_operation_page, .profile_page_container {
  z-index: 1;
  flex-direction: column;
  row-gap: 30px;
  column-gap: 10px;
  display: flex;
  justify-content: space-between;
  padding: 168px 50px 10px;
}

@media (max-width: 600px) {
  .car_operation_page, .completed_cars_container, .profile_page_container {
    padding: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/pages.sass"],"names":[],"mappings":"AAMA;EALE,sBAM2B;EAL3B,aAKmC;EAJnC,eAIyC;EAHzC,aAAA;EAIA,YAAA;EACA,YAAA;EACA,UAAA;EACA,wBAAA;AAFF;;AAIA;EACE,UAAA;EAbA,sBAc2B;EAb3B,aAamC;EAZnC,gBAYyC;EAXzC,aAAA;EAYA,8BAAA;EACA,wBAAA;AAEF;;AADA;EACE,UAAA;EAlBA,sBAmB2B;EAlB3B,aAkBmC;EAjBnC,gBAiByC;EAhBzC,aAAA;EAiBA,8BAAA;EACA,wBAAA;AAOF;;AALA;EACE;IACE,aAAA;EAQF;AACF","sourcesContent":["@mixin default_container($flex-direction: row, $row_gap, $column_gap)\n  flex-direction: $flex-direction\n  row-gap: $row_gap\n  column-gap: $column_gap\n  display: flex\n\n.login_page_container\n  @include default_container(column, 10px, 0px)\n  height: 100%\n  color: white\n  z-index: 1\n  padding: 180px 70px 70px\n\n.completed_cars_container\n  z-index: 1\n  @include default_container(column, 10px, 10px)\n  justify-content: space-between\n  padding: 130px 50px 10px\n.car_operation_page, .profile_page_container\n  z-index: 1\n  @include default_container(column, 30px, 10px)\n  justify-content: space-between\n  padding: 168px 50px 10px\n\n@media (max-width: 600px)\n  .car_operation_page, .completed_cars_container, .profile_page_container\n    padding: 10px"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
